<template>
  <div class="form tab-content" id="building-operator-section">
    <v-layout column>
      <v-layout row justify-space-between align-end style="margin-right: 20px">
        <input-field
          :value="numberOperators"
          :label="$t('NumberOperators')"
          size="small"
          inputType="text"
          :field-disabled="true"
        />

        <v-btn
          v-if="!disabled"
          @click="addOperator"
          x-small
          icon
          text
          color="accent"
          class="ma-0"
          :disabled="operators.length >= 6"
        >
          <v-icon>add_circle</v-icon>
        </v-btn>
      </v-layout>

      <v-layout column v-if="numberOperators > 0">
        <input-field
          value=""
          :label="$t('OperatorList')"
          size="large"
          inputType="group"
        />

        <div
          v-if="operators.length > 0"
          v-for="(operator, index) in operators"
          :key="index"
          style="margin: 10px 20px 0 20px"
        >
          <v-card flat>
            <v-layout row align-center justify-space-around>
              <input-field
                v-model="operator.bo_operator"
                label=""
                input-type="select"
                size="small"
                select-options="list_bo_operator"
                :placeholder="$tc('Operator', 1)"
                :form-disabled="disabled"
                :clearable="false"
              />

              <input-field
                v-model="operator.bo_ited"
                label=""
                input-type="select"
                size="small"
                select-options="list_bo_operator_ited"
                placeholder="ITED"
                :form-disabled="disabled"
                :clearable="false"
              />

              <input-field
                v-model="operator.bo_pdo_number"
                label=""
                input-type="text"
                size="small"
                placeholder="Nr. PDO"
                :form-disabled="disabled"
                :clearable="false"
              />

              <input-field
                v-model="operator.bo_pdo_installation"
                label=""
                input-type="select"
                size="small"
                select-options="list_bo_pdo_installation"
                placeholder="PDO"
                :form-disabled="disabled"
                :clearable="false"
              />

              <v-btn
                v-if="!disabled"
                @click="removeOperator(index)"
                x-small
                icon
                text
                color="accent"
                class="ma-0"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </v-layout>
          </v-card>
        </div>
      </v-layout>
    </v-layout>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import InputField from "@/components/Home/Forms/_Molecules/InputField";

export default {
  name: "BuildingOperatorSection",

  components: { InputField },

  props: {
    originalOperators: {
      type: Object
    },

    disabled: {
      type: Boolean
    }
  },

  data() {
    return {
      operators: [],
      numberOperators: 0,
      emptyOperator: {
        bo_operator: "2",
        bo_ited: "1",
        bo_pdo_number: null,
        bo_pdo_installation: "1"
      }
    };
  },

  mounted() {
    this.parseOriginalOperators();
  },

  methods: {
    ...mapActions(["GET_LIST"]),

    parseOriginalOperators() {
      this.numberOperators = this.originalOperators.bd_demand_point_num_operators;
      if (this.originalOperators.building_operator) {
        this.operators = JSON.parse(
          JSON.stringify(this.originalOperators.building_operator)
        );
        this.updateNumberOperators();
      }
    },

    addOperator() {
      let newOperator = Object.assign({}, this.emptyOperator);
      this.operators.push(newOperator);
      this.updateNumberOperators();
    },

    removeOperator(index) {
      this.operators.splice(index, 1);
      this.updateNumberOperators();
    },

    updateNumberOperators() {
      this.numberOperators = this.operators.length;
    }
  },

  watch: {
    originalOperators() {
      this.parseOriginalOperators();
    },

    numberOperators(newValue) {
      this.$emit("updateNumberOperators", newValue);
    },

    operators: {
      handler(newSet) {
        this.$emit("updateOperatorsList", newSet);
      },
      deep: true
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Buildings/Operators.vue